import { useLocation } from "react-router-dom";

const useProduct = () => {
    const searchParams = new URLSearchParams(useLocation().search);
    return searchParams.get("product");
};

export default useProduct;
